import { Criteria } from "~/context/Shared/domain/criteria/Criteria";
import { DocumentRepository } from "../domain/DocumentRepository";
import { Page } from "~/context/Shared/domain/page/Page";
import { Document } from "../domain/Document";
import { PageFull } from "~/context/Shared/domain/page/PageFull";
import { Movement } from "~/context/Movements/domain/Movement";
import { VectiResult } from "~/context/Shared/domain/VectiResult";



export async function listBestMatchDocumentsForMovement(
  repository: DocumentRepository,
  companyId: string,
  movementId: string,
  tolerance:number
): Promise<VectiResult> {
  try {
    const retDocuments = await repository.findBestMatchForMovement(companyId, movementId, tolerance);    
    return Promise.resolve(new VectiResult(true, retDocuments));
  } catch (error) {
    console.error("(useBestMatchesForMovement) Error:", error);
    return Promise.resolve(new VectiResult(false, "Error en la busqueda de mejores coincidencias para el movimiento"))
  }
}

export async function listExpensesAsDocumentsFullByCompanyAndCriteria(
  repository: DocumentRepository,
    companyId: string,
    criteria:Criteria
): Promise<VectiResult> {
  try {
    const retExpense = await repository.getExpensesAsDocumentsFullByCompanyAndCriteria(companyId, criteria);    
    console.log("(listExpensesAsDocumentsFullByCompanyAndCriteria) ret: ", JSON.stringify(retExpense));
    return Promise.resolve(new VectiResult(true, retExpense));
  } catch (error) {
    console.error("(listExpensesAsDocumentsFullByCompanyAndCriteria) Error:", error);
    return Promise.resolve(new VectiResult(false, "Error en la busqueda de expenses"))
  }

}



export async function listNearDocumentsForMovement(
  repository: DocumentRepository,
  companyId: string,
  movementId: string,
  criteria:Criteria
): Promise<VectiResult> {
  try {
    const retDocuments = await repository.findNearDocumentsForMovement(companyId, movementId, criteria);  
    console.log("\nretDocuments:------> ", JSON.stringify(retDocuments));
    return Promise.resolve(new VectiResult(true, retDocuments));
  } catch (error) {
    console.error("(listNearDocumentsForMovement) Error:", error);
    return Promise.resolve(new VectiResult(false, "Error en la busqueda de documentos para el movimiento"))
  }
}

export async function listNearDocumentsForDocument(
  repository: DocumentRepository,
  companyId: string,
  documentId: string,
  type: string,
  criteria:Criteria
): Promise<VectiResult> {
  try {
    const retDocuments = await repository.findNearDocumentsForDocument(companyId, documentId, type, criteria);  
    console.log("\nretDocumentsForDocyments:------> ", JSON.stringify(retDocuments));
    return Promise.resolve(new VectiResult(true, retDocuments));
  } catch (error) {
    console.error("(listNearDocumentsForDocument) Error:", error);
    return Promise.resolve(new VectiResult(false, "Error en la busqueda de documentos para el documento"))
  }
}

export function listDocumentsFullByCompanyAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  criteria: Criteria
): Promise<Page<Document>> {
  console.log("(listDocumentsFullByCompanyAndCriteria) : company_uid: ", company_uid, " criteria: ", criteria);
  return documentRepository.getDocumentsFullByCompanyAndCriteria(
    company_uid,
    criteria
  );
}

export async function listTop10PendingIncomeInvoices(
  documentRepository: DocumentRepository,
  company_uid: string): Promise<VectiResult> {
  
  try {
    const result = await documentRepository.listTop10PendingIncomeInvoices(company_uid);
    return new VectiResult(true, result);
  } catch (error) {
    console.log("(listTop10PendingIncomeInvoices) error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function listTop10OverdueOutcomeInvoices(
  documentRepository: DocumentRepository,
  company_uid: string): Promise<VectiResult> {
  
  try {
    const result = await documentRepository.listTop10OverdueOutcomeInvoices(company_uid);
    return new VectiResult(true, result);
  } catch (error) {
    console.log("(listTop10OverdueOutcomeInvoices) error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function listTop10FutureOutcomeInvoices(
  documentRepository: DocumentRepository,
  company_uid: string): Promise<VectiResult> {
  
  try {
    const result = await documentRepository.listTop10FutureOutcomeInvoices(company_uid);
    return new VectiResult(true, result);
  } catch (error) {
    console.log("(listTop10FutureOutcomeInvoices) error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function listTop10FutureIncomeInvoices(
  documentRepository: DocumentRepository,
  company_uid: string): Promise<VectiResult> {
  
  try {
    const result = await documentRepository.listTop10FutureIncomeInvoices(company_uid);
    return new VectiResult(true, result);
  } catch (error) {
    console.log("(listTop10FutureIncomeInvoices) error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function listTop10FutureOutcomeDocuments(
  documentRepository: DocumentRepository,
  company_uid: string): Promise<VectiResult> {
  
  try {
    const result = await documentRepository.listTop10FutureOutcomeDocuments(company_uid);
    return new VectiResult(true, result);
  } catch (error) {
    console.log("(listTop10FutureOutcomeDocuments) error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function listTop10FutureIncomeDocuments(
  documentRepository: DocumentRepository,
  company_uid: string): Promise<VectiResult> {
  
  try {
    const result = await documentRepository.listTop10FutureIncomeDocuments(company_uid);
    return new VectiResult(true, result);
  } catch (error) {
    console.log("(listTop10FutureIncomeInvoices) error:" + error);
    return new VectiResult(false, "Error");
  }
}




// TODO: metodos sin revisar
export function listDocumentsByCompanyAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  criteria: Criteria
): Promise<Page<Document>> {
  console.log("(listDocumentsByCompanyAndCriteria) : company_uid: ", company_uid, " criteria: ", criteria);
  return documentRepository.getDocumentsByCompanyAndCriteria(
    company_uid,
    criteria
  );
}

export function listDocumentsByCompanyDistanceAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  movement_uid: string,
  criteria: Criteria
): Promise<Page<Document>> {
  console.log("dentro de listDocumentsByCompanyDistanceAndCriteria : company_uid: ", company_uid, " criteria: ", criteria, " movement_uid: ", movement_uid);
  return documentRepository.getDocumentsByCompanyDistanceAndCriteria(
    company_uid,
    movement_uid,
    criteria
  );
}

export async function listDocumentsByCompanyDistanceAndCriteriaWithMovement(
  documentRepository: DocumentRepository,
  company_uid: string,
  movement: Movement,
  criteria: Criteria
): Promise<Page<Document>> {
  try {
    const movementId = movement.uid;
    console.log("dentro de listDocumentsByCompanyDistanceAndCriteria : company_uid: ", company_uid, " criteria: ", criteria, " movement_uid: ", movementId);
    const ret = await documentRepository.getDocumentsByCompanyDistanceAndCriteria(company_uid, movementId.toString(), criteria);
    const documents = orderByDifference(ret, movement);
    // console.log("retorno listDocumentsByCompanyDistanceAndCriteriaWithMovement: " + JSON.stringify(documents));
    return new Page<Document>(documents.length, documents);
  } catch (error) {
    console.log("error en listDocumentsByCompanyDistanceAndCriteriaWithMovement: ", error);
    return new Page<Document>(0, []);
  }

}

function orderByDifference(response: Page<Document>, movement: Movement): Document[] {
  console.log("dentro de orderByDifference" + response.content.length);
  const pageDocument = response.content.map((doc) => {
    //  console.log("doc: ", JSON.stringify(doc));
    //  console.log("movement: ", movement.movement_total_amount);
    //  console.log("doc.document_total_amount: ", doc.document_total_amount);
    const movementBalance = movement.movement_balance || 0;
    const documentBalance = doc.document_balance || 0;
    //  console.log("movementBalance: ", movementBalance);
    // console.log("documentBalance: ", documentBalance);

    //    console.log("difference: ", Math.abs(documentBalance - movementBalance));
    return ({
      ...doc,
      difference: Math.abs(documentBalance - movementBalance)
    })
  })
    .sort((a, b) => a.difference - b.difference)
    .map((doc) => doc);
  return pageDocument;

}


export function listFullDocumentsByCompanyAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullDocumentsByCompanyAndCriteria : company_uid: ", company_uid, " criteria: ", criteria);
  return documentRepository.getFullDocumentsByCompanyAndCriteria(
    company_uid,
    criteria
  );
}

export function listFullIncomeDocumentsByCompanyAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullIncomeDocumentsByCompanyAndCriteria : company_uid: ", company_uid, " criteria: ", criteria);
  return documentRepository.getFullIncomeDocumentsByCompanyAndCriteria(
    company_uid,
    criteria
  );
}

export function listFullIncomeDocumentsByCompanyClientAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  client_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullIncomeDocumentsByCompanyClientAndCriteria : company_uid: " + company_uid + " client_uid: " + client_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getFullIncomeDocumentsByCompanyClientAndCriteria(
    company_uid,
    client_uid,
    criteria
  );
}

export function listFullOutcomeDocumentsByCompanyProviderAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  provider_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullOutcomeDocumentsByCompanyProviderAndCriteria : company_uid: " + company_uid + " provider_uid: " + provider_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getFullOutcomeDocumentsByCompanyProviderAndCriteria(
    company_uid,
    provider_uid,
    criteria
  );
}


export function listFullDocumentsInvoicesBillsByCompanyProviderAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  provider_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullDocumentsInvoicesBillsByCompanyProviderAndCriteria : company_uid: " + company_uid + " provider_uid: " + provider_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getFullDocumentsInvoicesBillsByCompanyProviderAndCriteria(
    company_uid,
    provider_uid,
    criteria
  );
}

export function listFullDocumentsCreditsByCompanyProviderAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  provider_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullDocumentsCreditsByCompanyProviderAndCriteria : company_uid: " + company_uid + " provider_uid: " + provider_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getFullDocumentsCreditsByCompanyProviderAndCriteria(
    company_uid,
    provider_uid,
    criteria
  );
}



export function listFullOutcomeDocumentsByCompanyCollaboratorAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  collaborator_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullOutcomeDocumentsByCompanyCollaboratorAndCriteria : company_uid: " + company_uid + " collaborator_uid: " + collaborator_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getFullOutcomeDocumentsByCompanyCollaboratorAndCriteria(
    company_uid,
    collaborator_uid,
    criteria
  );
}

export function listFullOutcomeDocumentsByCompanyEmployeeAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  employee_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullOutcomeDocumentsByCompanyProviderAndCriteria : company_uid: " + company_uid + " employee_uid: " + employee_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getFullOutcomeDocumentsByCompanyEmployeeAndCriteria(
    company_uid,
    employee_uid,
    criteria
  );
}

export function listFullDocumentsByCompanyEmployeeAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  employee_uid: string,
  criteria: Criteria
): Promise<PageFull<Document>> {
  console.log("dentro de listFullDocumentsByCompanyProviderAndCriteria : company_uid: " + company_uid + " employee_uid: " + employee_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getFullDocumentsByCompanyEmployeeAndCriteria(
    company_uid,
    employee_uid,
    criteria
  );
}


export function listSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  employee_uid: string,
  criteria: Criteria
): Promise<[PageFull<Document>, PageFull<Document>]> {
  console.log("dentro de listSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria : company_uid: " + company_uid + " employee_uid: " + employee_uid + " criteria: " + JSON.stringify(criteria));
  return documentRepository.getSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria(
    company_uid,
    employee_uid,
    criteria
  );
}




export async function listFullOutcomeDocumentsByCompanyAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  criteria: Criteria
): Promise<Page<Document>> {
  console.log("dentro de listFullOutcomeDocumentsByCompanyAndCriteria : company_uid: ", company_uid, " criteria: ", criteria);
  const ret = await documentRepository.getFullOutcomeDocumentsByCompanyAndCriteria(
    company_uid,
    criteria
  );
  console.log("retorno listFullOutcomeDocumentsByCompanyAndCriteria: " + JSON.stringify(ret));
  return ret;
}


export function listDocumentsFullRepositoryByCompanyAndSearch(
  documentRepository: DocumentRepository,
  company_uid: string,
  search: string
): Promise<Page<Document>> {
  const ret = documentRepository.getDocumentsFullRepositoryByCompanyAndSearch(
    company_uid,
    search
  );
  console.log("listMovementsRepositoryByCompanyAndSearch: ", JSON.stringify(ret));
  return ret;
}

export function listDocumentsFullRepositoryByCompanySearchAndClient(
  documentRepository: DocumentRepository,
  company_uid: string,
  search: string,
  client_uid: string
): Promise<Page<Document>> {
  const ret = documentRepository.getDocumentsFullRepositoryByCompanySearchAndClient(
    company_uid,
    search,
    client_uid
  );
  console.log("listDocumentsFullRepositoryByCompanySearchAndClient: ", JSON.stringify(ret));
  return ret;
}


export function listDocumentsFullRepositoryByCompanySearchProviderAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  search: string,
  provider_uid: string,
  criteria: Criteria
): Promise<Page<Document>> {
  const ret = documentRepository.getDocumentsFullRepositoryByCompanySearchProviderAndCriteria(
    company_uid,
    search,
    provider_uid,
    criteria
  );
  console.log("listDocumentsFullRepositoryByCompanySearchProviderAndCriteria: ", JSON.stringify(ret));
  return ret;
}

export function listDocumentsFullRepositoryByCompanySearchAndProvider(
  documentRepository: DocumentRepository,
  company_uid: string,
  search: string,
  provider_uid: string,
): Promise<Page<Document>> {
  const ret = documentRepository.getDocumentsFullRepositoryByCompanySearchAndProvider(
    company_uid,
    search,
    provider_uid
  );
  console.log("listDocumentsFullRepositoryByCompanySearchAndProvider: ", JSON.stringify(ret));
  return ret;
}


export function listDocumentsFullByCompanyYearMonthAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  year:number,
  month:number,  
  criteria: Criteria
): Promise<Page<Document>> {
  const ret = documentRepository.getDocumentsFullByCompanyYearMonthAndCriteria(
    company_uid,
    year,
    month,
    criteria
  );
  console.log("listDocumentsFullByCompanyYearMonthAndCriteria: ", JSON.stringify(ret));
  return ret;
}

export function listDocumentsFullByCompanyYearAndCriteria(
  documentRepository: DocumentRepository,
  company_uid: string,
  year:number,
  criteria: Criteria
): Promise<Page<Document>> {
  const ret = documentRepository.getDocumentsFullByCompanyYearAndCriteria(
    company_uid,
    year,
    criteria
  );
  console.log("listDocumentsFullByCompanyYearAndCriteria: ", JSON.stringify(ret));
  return ret;
}



export function listDocumentsByCompanyTypeYearMonth(
  documentRepository: DocumentRepository,
  company_uid: string,
  document_type: string,
  document_year:string,
  document_month:string,
  criteria: Criteria
): Promise<Page<Document>> {
  const ret = documentRepository.getDocumentsByCompanyTypeYearMonth(
    company_uid,
    document_type,
    document_year,
    document_month,
    criteria
  );
  console.log("listDocumentsByCompanyTypeYearMonth: ", JSON.stringify(ret));
  return ret;
}

export function listIncomeDocumentsByCompanyTypeYearMonth(
  documentRepository: DocumentRepository,
  company_uid: string,
  document_type: string,
  document_year:string,
  document_month:string,
  criteria: Criteria
): Promise<Page<Document>> {
  const ret = documentRepository.getIncomeDocumentsByCompanyTypeYearMonth(
    company_uid,
    document_type,
    document_year,
    document_month,
    criteria
  );
  console.log("listDocumentsByCompanyTypeYearMonth: ", JSON.stringify(ret));
  return ret;
}
